import { useMemo } from 'react'
import { Arr } from '../../../helpers/Arr'
import { installReqClasses } from '../../../types/constants'
import { IElementProps } from '../../../types/interfaces'
const GeneratedImage = (props: IElementProps) => {
  const { data, fieldsToListen } = props

  const classesCars = useMemo<string[]>(() => {
    let c: string[] = []
    if (Arr.any(fieldsToListen)) {
      fieldsToListen.forEach((f) => {
        if (data[f]) {
          c.push(`${data[f]}`)
        }
      })
    } else {
      if (props.defaultValue) {
        const defaultClasses = props.defaultValue?.split(', ')
        c = defaultClasses
      }
    }

    return c
  }, [data, props.defaultValue])

  const classesIns = useMemo<string[]>(() => {
    let c: string[] = []
    if (Arr.any(fieldsToListen)) {
      fieldsToListen.forEach((f) => {
        if (data[f]) {
          c.push(`${f}-${data[f]}`)
        }
      })
    } else {
      if (props.defaultValue) {
        const defaultClasses = props.defaultValue.split(', ')
        c = defaultClasses
      }
    }

    return c
  }, [data])

  function installCheck(installClass: string) {
    return classesIns.some((el) => el.toLowerCase().indexOf(`install_${installClass}`) > -1)
  }
  return (
    <>
      {props.visible && (
        <div
          style={{
            color: `${
              fieldsToListen.includes('car_color')
                ? data['car_color'] !== 'white'
                  ? data['car_color'] || 'black'
                  : 'black'
                : 'black'
            }`,
          }}
          className={`formGroup generated-image ${props.class}`}
        >
          <div className={`generatedImage ${classesCars.join(' ')}`}>
            {(classesCars.includes('standard') || classesCars.includes('standardplus')) &&
              !classesCars.includes('NV') &&
              (classesCars.includes('partial') ? (
                <i className="icon-car-halfwrap" />
              ) : classesCars.includes('full') ? (
                <i className="icon-car-wrap" />
              ) : (
                <i className={`icon-car-big${data['car_color'] === 'white' ? '-white' : ''}`} />
              ))}
            {/*// standart private */}
            {(classesCars.includes('standard') || classesCars.includes('standardplus')) &&
              classesCars.includes('NV') &&
              (classesCars.includes('partial') ? (
                <i className="icon-van-halfwrap" />
              ) : classesCars.includes('full') ? (
                <i className="icon-van-wrap" />
              ) : (
                <i className={`icon-van-big${data['car_color'] === 'white' ? '-white' : ''}`} />
              ))}
            {classesCars.includes('nonstandard') && !classesCars.includes('NV') && (
              <i className={`icon-cabrio${data['car_color'] === 'white' ? '-white' : ''}`} />
            )}
            {classesCars.includes('nonstandard') &&
              classesCars.includes('NV') &&
              (classesCars.includes('partial') ? (
                <i className="icon-truck-halfwrap" />
              ) : classesCars.includes('full') ? (
                <i className="icon-truck-wrap" />
              ) : (
                <i className={`icon-truck-big${data['car_color'] === 'white' ? '-white' : ''}`} />
              ))}
            {installCheck(installReqClasses.required) &&
              !installCheck(installReqClasses.left) &&
              !installCheck(installReqClasses.right) &&
              !installCheck(installReqClasses.middle) && <i className="icon-inEmpty" />}
            {installCheck(installReqClasses.left) &&
              !installCheck(installReqClasses.right) &&
              !installCheck(installReqClasses.middle) && <i className="icon-inLeft" />}
            {!installCheck(installReqClasses.left) &&
              installCheck(installReqClasses.right) &&
              !installCheck(installReqClasses.middle) && <i className="icon-inRight" />}
            {!installCheck(installReqClasses.left) &&
              !installCheck(installReqClasses.right) &&
              installCheck(installReqClasses.middle) && <i className="icon-inCenter" />}
            {installCheck(installReqClasses.left) &&
              installCheck(installReqClasses.right) &&
              !installCheck(installReqClasses.middle) && <i className="icon-inLeftRight" />}
            {installCheck(installReqClasses.left) &&
              !installCheck(installReqClasses.right) &&
              installCheck(installReqClasses.middle) && <i className="icon-inLeftCenter" />}
            {!installCheck(installReqClasses.left) &&
              installCheck(installReqClasses.right) &&
              installCheck(installReqClasses.middle) && <i className="icon-inRightCenter" />}
            {installCheck(installReqClasses.right) &&
              installCheck(installReqClasses.left) &&
              installCheck(installReqClasses.middle) && <i className="icon-inAll" />}

            {/* <i style={{fontSize: '90px'}} className='icon-van-big' />
              <i style={{fontSize: '90px'}} className='icon-van-halfwrap' /> // standart commercial 
              <i style={{fontSize: '90px'}} className='icon-van-wrap' />
              
              <i style={{fontSize: '90px'}} className='icon-cabrio' /> // non standart private 
    
              <i style={{fontSize: '90px'}} className='icon-truck-big' />
              <i style={{fontSize: '90px'}} className='icon-truck-halfwrap' /> // non standart commercial 
              <i style={{fontSize: '90px'}} className='icon-truck-wrap' /> */}
          </div>
        </div>
      )}
    </>
  )
}
export default GeneratedImage
